/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
    APIResponseErrorToJSONTyped,
} from './APIResponseError';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
    APIMetaToJSONTyped,
} from './APIMeta';

/**
 * 
 * @export
 * @interface PostPersonsAnonymous201Response
 */
export interface PostPersonsAnonymous201Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof PostPersonsAnonymous201Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof PostPersonsAnonymous201Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {string}
     * @memberof PostPersonsAnonymous201Response
     */
    result: string;
}

/**
 * Check if a given object implements the PostPersonsAnonymous201Response interface.
 */
export function instanceOfPostPersonsAnonymous201Response(value: object): value is PostPersonsAnonymous201Response {
    if (!('result' in value) || value['result'] === undefined) return false;
    return true;
}

export function PostPersonsAnonymous201ResponseFromJSON(json: any): PostPersonsAnonymous201Response {
    return PostPersonsAnonymous201ResponseFromJSONTyped(json, false);
}

export function PostPersonsAnonymous201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPersonsAnonymous201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'meta': json['meta'] == null ? undefined : APIMetaFromJSON(json['meta']),
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': json['result'],
    };
}

export function PostPersonsAnonymous201ResponseToJSON(json: any): PostPersonsAnonymous201Response {
    return PostPersonsAnonymous201ResponseToJSONTyped(json, false);
}

export function PostPersonsAnonymous201ResponseToJSONTyped(value?: PostPersonsAnonymous201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'meta': APIMetaToJSON(value['meta']),
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(APIResponseErrorToJSON)),
        'result': value['result'],
    };
}

